import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../hooks/useFetchData";
import { getPublishedByOthersActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";
import { publishedByOthers } from "../../../utils/mainTabs/manage/publishedByOthers";

const PublishedByOthers = () => {
  const navigate = useNavigate();
  const { tenantName, refreshAPIS, setRefreshAPIS } = useOutletContext();
  const pageSize = 8;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getPublishedByOthersActionHandler, pageSize);
  const { searchPlaceHolder, columns } = publishedByOthers;
  useEffect(() => {
    if (refreshAPIS) {
      handleSearchQuery("");
      setRefreshAPIS(false);
    }
  }, [refreshAPIS]);
  return (
    <DataTable
      columns={columns(navigate, tenantName)}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default PublishedByOthers;
